"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ReviewReportAwaitingApprovalModel", {
    enumerable: true,
    get: function() {
        return ReviewReportAwaitingApprovalModel;
    }
});
const _zod = /*#__PURE__*/ _interop_require_default(require("zod"));
const _reviewreport = require("./review-report");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const ReviewReportAwaitingApprovalModel = _reviewreport.ReviewReportModel.pick({
    _id: true,
    author: true,
    authors: true,
    authors_due_date: true,
    company: true,
    deleted: true,
    deleted_at: true,
    form_comment: true,
    form_id: true,
    form_assignment_id: true,
    redacted: true,
    review_parent: true,
    signer: true,
    signers: true,
    signers_due_date: true,
    start_date: true,
    subject: true,
    visible: true
}).extend({
    approval_status: _reviewreport.ReviewReportEasyAddApprovalStatus.exclude([
        "approved"
    ]),
    easy_add: _zod.default.literal(true),
    easy_add_data: _reviewreport.ReviewReportModel.shape.easy_add_data.unwrap()
});
